module.exports = "/images/clap.svg?c78ccdb9b939bf3f7f64cbff1e5096bc";